import { Suspense, lazy, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

/**
 * The foot of the landing page: the privacy document and a way to write to us.
 * The language and theme choices are the header's.
 *
 * The contact form is fetched only when somebody opens it. It talks to Supabase,
 * and a marketing page that has not been asked for anything should not be
 * carrying a database client through its first paint.
 */
const ContactUsForm = lazy(async () => ({
  default: (await import("@/components/ContactUsForm")).ContactUsForm,
}));

export function LandingFooter() {
  const { t } = useTranslation();
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <footer
      data-testid="landing-footer"
      className="mx-auto flex w-full max-w-5xl flex-col items-center gap-6 border-t border-border px-4 py-10"
    >
      <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
        <a
          href="/privacy"
          className="text-muted-foreground underline underline-offset-4"
        >
          {t("entry.privacy")}
        </a>
        <Dialog open={contactOpen} onOpenChange={setContactOpen}>
          <DialogTrigger className="text-muted-foreground underline underline-offset-4">
            {t("settings.contactUs")}
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{t("settings.contactUs")}</DialogTitle>
            </DialogHeader>
            {contactOpen ? (
              <Suspense fallback={null}>
                <ContactUsForm />
              </Suspense>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
    </footer>
  );
}

export default LandingFooter;
